import { getSubId, getCamId, getOcid, getPOcid, getObid, getAid } from './identifiers.js';
import { decodeHtml, replaceAll, getPlaceholder } from './utils.js';

export const getAutoringPoolNumber = (ringPoolIDs, typeId, callback) => {
    const baseURL = '//rs.cfringctr.com';
    const url = `${baseURL}/api/ReserveNumbers/?ringPoolIDs=${JSON.stringify(ringPoolIDs)}&subid=${getSubId()}&typeid=${typeId}&camid=${getCamId()}&cluster_text=${encodeURIComponent($('#customfield1').val()) || ''}&aid=${getAid()}&ocid=${getOcid()}&pocid=${getPOcid()}&obid=${getObid()}&callback=?`;

    $.ajax({
        dataType: 'jsonp',
        type: 'get',
        url: url,
        success: (response) => {
            callback(response.response);
            // Debugging:
            response?.response?.forEach((node) => {
                console.log({typeid: typeId, tfn: node.ring_pool_id, rpid: decodeHtml(node.number)});
            });
        },
        error: (xhr, status, error) => {
            const errorMsg = encodeURIComponent(JSON.stringify({ request: xhr, status, error, session_id: getSubId() }));
            $.ajax({
                dataType: 'jsonp',
                type: 'get',
                url: `${baseURL}/api/ReserveTimeout/?ringPoolIDs=${JSON.stringify(ringPoolIDs)}&subid=${getSubId()}&typeid=${typeId}&camid=${getCamId()}&errorMsg=${errorMsg}&callback=?`,
            });
        },
    });
};

export const setDisplayNumbers = (ringPoolID, number) => {
    const placeholders = `a[ringpoolid=${ringPoolID}], span[ringpoolid=${ringPoolID}]`;

    $(placeholders).each(function () {
        try {
            const decodedNumber = decodeHtml(number);
            if (this.href && this.href.match('^tel:')) {
                this.href = this.href.replace(getPlaceholder(this), decodedNumber);
                $(this).html(replaceAll($(this).html(), getPlaceholder(this), decodedNumber)).show();
            }
        } catch (e) {
            console.error(e);
        }
    });
};

export const formatPhoneNumber = (phoneNumber, format) => {
    if (!phoneNumber || !format) return phoneNumber;

    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    let formattedNumber = format;

    for (let i = 0, j = 0; i < format.length; i++) {
      if (format[i] === 'x') {
        formattedNumber = formattedNumber.replace('x', cleaned[j++] || '');
      }
    }

    return formattedNumber;
};

export const setType2Attribute = (ringPoolID, number) => {
    const placeholders = `a[ringpoolid=${ringPoolID}], span[ringpoolid=${ringPoolID}]`;

    $(placeholders).each(function () {
        try {
            const decodedNumber = decodeHtml(number);
            this.setAttribute('data-ringpool-type2', decodedNumber);
        } catch (e) {
            console.error(e);
        }
    });
};
